import React from 'react'
import { useTranslation } from 'react-i18next'
import { useNavigate } from 'react-router-dom'
import Heading from '../../components/Heading'
import IconButton from '../../components/IconButton'
import { faArrowLeft } from '@fortawesome/free-solid-svg-icons'
import Text from '../../components/Text'
import FulfillmentList from '../../compositions/Settings/FulfillmentSettings/FulfillmentList'
import {usePluginContext} from "../../contexts/PluginContext";

const FontSettings: React.FC = () => {
    const { t } = useTranslation(['settings'])
    const navigate = useNavigate()
    const { plugin } = usePluginContext()

    return (
        <>
            <Heading level={3} classes={'zr-my-4'}>
                {t('fulfillment.heading')}
            </Heading>
            <IconButton
                icon={faArrowLeft}
                color={'black'}
                onClick={() => navigate('/settings')}
            >
                {t('common.backToOverview')}
            </IconButton>
            <Text classes={'zr-mt-3'}>{t('fulfillment.description')}</Text>

            {t('fulfillment.externalAccess')}: <a href={plugin?.externalUrl} target={'_blank'}>{plugin?.externalUrl}</a>
            <br/><small>{t('fulfillment.externalAccessProblem')}: <a href={'#'} onClick={() => navigate('/settings/advanced')}>{t('overview.advanced.action')}</a></small>
            <FulfillmentList />
        </>
    )
}

export default FontSettings
